import React, { useEffect, useState, useRef, Fragment, memo } from 'react';
import MemoryEngine from './MemoryEngine';
import VoiceAILayer from './VoiceAILayer';
import MultiAngelGroupChat from './MultiAngelGroupChat';
import { trackProductView, trackSearchTerm } from './PersonalizedRecommendations';
import { Heart, MessageCircle, Share2, Bookmark, MoreHorizontal, Lock, Gift, MapPin, Flame, Video, Image as ImageIcon, Play, Clock, ChevronRight, Camera, CheckCircle, Zap, Star, Crown, X, Plus, Sparkles, Bell, BellOff, Flag, ListPlus, UserPlus, Mic, DollarSign, Award, Headphones, ThumbsUp, Calendar, ArrowUp, Search, Filter, Users, Diamond, Trophy, Shield, ChevronLeft } from 'lucide-react';
import { VideoGenerationUpsell } from './VideoGenerationUpsell';
import { PersonalizedRecommendationsBanner } from './PersonalizedRecommendationsBanner';
import { ImageGenerationUpsell } from './ImageGenerationUpsell';
import { GenerationUpsellCTA } from './GenerationUpsellCTA';
import { RelationshipTracker } from './RelationshipTracker';
import { EmotionalBondMeter } from './EmotionalBondMeter';
import { DickpicRatingUpsell } from './DickpicRatingUpsell';
import { FeedFilterBar } from './FeedFilterBar';
import { FloatingActionButton } from './FloatingActionButton';
import { DailyProgressWidget } from './DailyProgressWidget';
// New import for responsive image handling
import { ResponsiveImage } from './uncover/ResponsiveImage';
import { PhotoRatingFlow } from './PhotoRatingFlow';
import { useQuestionnaire } from './personalization/QuestionnaireContext';
interface CustomerProfileProps {
  onNavigate?: (section: string) => void;
}
export const CustomerProfile: React.FC<CustomerProfileProps> = ({
  onNavigate
}) => {
  const [activeTab, setActiveTab] = useState('forYou');
  const [activeFilter, setActiveFilter] = useState('for_you');
  const [likedPosts, setLikedPosts] = useState<Record<string, boolean>>({});
  const [followedAngels, setFollowedAngels] = useState<string[]>(['Sophia', 'Eva', 'Lana']);
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const [dailyMissionProgress, setDailyMissionProgress] = useState(1);
  const [showUnlockModal, setShowUnlockModal] = useState(false);
  const [unlockPostId, setUnlockPostId] = useState<string | null>(null);
  const [showTipOptions, setShowTipOptions] = useState(false);
  const [tipPostId, setTipPostId] = useState<string | null>(null);
  const [isPlaying, setIsPlaying] = useState<string | null>(null);
  const [showARMode, setShowARMode] = useState(false);
  const [xpEarned, setXpEarned] = useState<{
    id: string;
    value: number;
  } | null>(null);
  const [timeLeft, setTimeLeft] = useState({
    hours: 5,
    minutes: 23,
    seconds: 45
  });
  const [showRecommendations, setShowRecommendations] = useState(true);
  const [showVideoUpsellModal, setShowVideoUpsellModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showImageGeneratorModal, setShowImageGeneratorModal] = useState(false);
  const [showDickpicRatingModal, setShowDickpicRatingModal] = useState(false);
  const [showDailyTargetsModal, setShowDailyTargetsModal] = useState(false);
  const [showPhotoRatingFlow, setShowPhotoRatingFlow] = useState(false);
  const navBarRef = useRef<HTMLDivElement>(null);
  const [debugInfo, setDebugInfo] = useState<string | null>(null);
  const componentRef = useRef<HTMLDivElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const audioRef = useRef<HTMLAudioElement>(null);
  const [showStoryModal, setShowStoryModal] = useState(false);
  const [activeStory, setActiveStory] = useState<number | null>(null);
  // New state for viewport detection
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  const [imageQuality, setImageQuality] = useState<'low' | 'medium' | 'high'>(window.innerWidth > 1200 ? 'high' : window.innerWidth > 768 ? 'medium' : 'low');
  const postContainerRef = useRef<HTMLDivElement>(null);
  const stories = [{
    id: 'story1',
    user: 'Sophia',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
    viewed: false,
    live: true,
    new: true
  }, {
    id: 'story2',
    user: 'Eva',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nBpXopQ7YXWmZqdTwR7HaM/image.png',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png',
    viewed: false,
    live: false,
    new: true
  }, {
    id: 'story3',
    user: 'Riley',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2myPwGWmEWGW4CWiQgdDdz/image.png',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png',
    viewed: true,
    live: false,
    new: false
  }];
  const openStory = (index: number) => {
    setActiveStory(index);
    setShowStoryModal(true);
  };
  const closeStory = () => {
    setShowStoryModal(false);
    setActiveStory(null);
  };
  // Feed posts data for different tabs
  const forYouPosts = [{
    id: 'post1',
    user: {
      name: 'Sophia',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
      verified: true
    },
    content: "Just finished my yoga session... who wants to see what's underneath this towel? 😉",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uyiXhnExYU79VjyGrEvQrS/masturbate.jpg',
    type: 'blur_image',
    likes: 243,
    comments: 42,
    time: '2h ago',
    locked: false,
    location: 'Yoga Studio',
    hashtags: ['#yoga', '#fitness', '#secretsunderneath'],
    topTippers: [{
      name: 'Michael',
      amount: 50
    }, {
      name: 'James',
      amount: 20
    }]
  }, {
    id: 'growthxl_review',
    user: {
      name: 'Ryan',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vxRMQY2SsyHiXjDdDVhfcA/image.png',
      verified: true
    },
    content: "Guys, I HAVE to share this! Been using GrowthXL Enlargement Formula for just 3 weeks and the results are INSANE! 🔥 My girlfriend can't stop talking about the difference. It's all natural ingredients too, which was important to me. Seriously life-changing - check the before/after pics I sent her (too explicit to post here lol). Anyone else tried this?",
    type: 'product_recommendation',
    likes: 427,
    comments: 118,
    time: '1d ago',
    locked: false,
    location: 'Private Time',
    hashtags: ['#GrowthXL', '#RealResults', '#SizeDoesMatter', '#NoMoreInsecurities'],
    product: {
      name: 'GrowthXL Enlargement Formula',
      price: 59.99,
      discount: 15,
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/n8fj5AnjCW6VfcJX1m8fen/image.png',
      description: 'Natural enlargement solution with visible results in 2 weeks',
      rating: 4.8,
      reviewCount: 842
    }
  }, {
    id: 'post2',
    user: {
      name: 'Eva',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nBpXopQ7YXWmZqdTwR7HaM/image.png',
      verified: true
    },
    content: 'What should I wear for our private session tonight? 💋',
    type: 'poll',
    likes: 189,
    comments: 56,
    time: '3h ago',
    locked: false,
    location: 'Bedroom',
    poll: {
      options: [{
        text: 'Red lingerie ❤️',
        percentage: 64
      }, {
        text: 'Nothing at all 🖤',
        percentage: 36
      }],
      endsIn: '3 hours'
    },
    hashtags: ['#fashion', '#lingerie', '#decisiontime']
  }, {
    id: 'post3',
    user: {
      name: 'Riley',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2myPwGWmEWGW4CWiQgdDdz/image.png',
      verified: true
    },
    content: 'I recorded this just for you... listen with headphones 🎧',
    type: 'audio',
    audioUrl: 'https://assets.mixkit.co/active_storage/sfx/212/212-preview.mp3',
    audioWaveform: [0.2, 0.5, 0.3, 0.8, 0.4, 0.6, 0.3, 0.5, 0.7, 0.8, 0.5, 0.3, 0.6, 0.4, 0.2],
    likes: 312,
    comments: 78,
    time: '4h ago',
    locked: false,
    location: 'Bedroom',
    hashtags: ['#voice', '#asmr', '#intimate']
  }, {
    id: 'post4',
    user: {
      name: 'Jasmine',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cbRc9jayz6abrUqY99QsFF/pasted-image.jpg',
      verified: true
    },
    content: "I've been thinking about you all day... can't wait to show you what's underneath 💦",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/t1fMgo9T4WadxWeynPJ6vb/videoblur.png',
    type: 'premium_content',
    likes: 427,
    comments: 92,
    time: '5h ago',
    locked: true,
    price: 8,
    location: 'Secret Spot',
    hashtags: ['#exclusive', '#premium', '#justforyou']
  }, {
    id: 'post5',
    user: {
      name: 'Sophia',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
      verified: true
    },
    content: "I had the most intense dream about you last night... I woke up so wet thinking about what we did in that hotel room. Still can't get it out of my mind. Should I tell you the details? 😈",
    type: 'confession',
    likes: 156,
    comments: 38,
    time: '7h ago',
    locked: false,
    hashtags: ['#dreams', '#confession', '#wetdreams']
  }, {
    id: 'post6',
    user: {
      name: 'Eva',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nBpXopQ7YXWmZqdTwR7HaM/image.png',
      verified: true
    },
    content: "🔴 GOING LIVE in 15 minutes! I'll be trying on new lingerie and need your help deciding what to keep...",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png',
    type: 'live_announcement',
    likes: 89,
    comments: 24,
    time: '15m ago',
    locked: false,
    liveDetails: {
      startsIn: '15 minutes',
      entryFee: 5,
      rewards: 'Top tippers get a private photo set!'
    },
    hashtags: ['#goingLive', '#lingerie', '#interactive']
  }, {
    id: 'post7',
    user: {
      name: 'Riley',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2myPwGWmEWGW4CWiQgdDdz/image.png',
      verified: true
    },
    content: 'Test my new toy? I just got this new vibrator that connects to the app... want to control it? 😏',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png',
    type: 'product_promo',
    likes: 215,
    comments: 63,
    time: '1d ago',
    locked: false,
    product: {
      name: 'Interactive Vibrator',
      price: 15,
      description: 'Control my pleasure with this app-connected toy!'
    },
    hashtags: ['#toys', '#interactive', '#control']
  }, {
    id: 'post8',
    user: {
      name: 'Jasmine',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cbRc9jayz6abrUqY99QsFF/pasted-image.jpg',
      verified: true
    },
    content: 'Try your luck! Roll the dice for a chance to win a special prize 🎲',
    type: 'mini_game',
    likes: 178,
    comments: 42,
    time: '1d ago',
    locked: false,
    game: {
      type: 'dice',
      prizes: ['Free photo', '5 tokens', '10% off VIP', 'Private message']
    },
    hashtags: ['#game', '#prizes', '#lucky']
  }, {
    id: 'post9',
    user: {
      name: 'Sophia',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bU73WvXeTZLjt1PKcu9KyE/image.png',
      verified: true
    },
    content: "Just got my boyfriend the MaxPower+ supplements and WOW 🔥 He's been able to go for hours now! I'm completely satisfied 😏 Has anyone else tried these?",
    type: 'product_recommendation',
    likes: 289,
    comments: 54,
    time: '1d ago',
    locked: false,
    location: 'Private Time',
    hashtags: ['#MaxPower', '#EnhancedPerformance', '#AllNightLong'],
    product: {
      name: 'MaxPower+ Performance Enhancer',
      price: 49.99,
      discount: 20,
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6gymBp7TU8GMLLGvrhyYDY/image.png',
      description: 'Clinically proven formula for enhanced performance & stamina'
    }
  }, {
    id: 'lana_post1',
    user: {
      name: 'Michael',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vxRMQY2SsyHiXjDdDVhfcA/image.png',
      verified: false
    },
    content: "Just saw @lana_luxe's new latex photoshoot and I'm speechless... 😍 This Angel is on another level! Anyone else a fan? #LatexGoddess #NewFavorite #MustFollow",
    type: 'text',
    likes: 187,
    comments: 42,
    time: '4h ago',
    locked: false,
    location: 'Fan Club',
    hashtags: ['#LatexGoddess', '#NewFavorite', '#MustFollow'],
    vpnUpsell: true
  }, {
    id: 'lana_post2',
    user: {
      name: 'James',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rniFdMuqf7v6dkhQTxAkvZ/image.png',
      verified: false
    },
    content: 'I sent @lana_luxe a pic for her to rate and her response made my whole week 🔥 Worth every token! Her Spicy Rating is the real deal guys. #VPNActivated #PicRating #WorthIt #VPNActivated',
    type: 'text',
    likes: 243,
    comments: 56,
    time: '6h ago',
    locked: false,
    location: 'Rating Club',
    hashtags: ['#PicRating', '#WorthIt', '#VPNActivated'],
    vpnUpsell: false
  }, {
    id: 'lana_post3',
    user: {
      name: 'David',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cbRc9jayz6abrUqY99QsFF/pasted-image.jpg',
      verified: false
    },
    content: "My wife almost caught me looking at @lana_luxe's private content last night... 😅 Thank god for SinShift VPN! No traces left behind. Her gold and black lingerie set is absolute fire btw 🔥 #CloseCall",
    type: 'text',
    likes: 312,
    comments: 78,
    time: '1d ago',
    locked: false,
    location: 'Secret Browser',
    hashtags: ['#CloseCall', '#SafeBrowsing', '#WorthTheRisk'],
    vpnUpsell: true
  }, {
    id: 'lana_self_post1',
    user: {
      name: 'Lana',
      username: 'lana_luxe',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg',
      verified: true
    },
    content: "Want my honest opinion? 😏 Send me your pics and I'll rate them 1-10. My Spicy Rating service is now open! You might be surprised what I think... 💋 #NoFilter #RawFeedback",
    type: 'image',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wiNDmy3jyz5k1YDhJsw7Zz/509629230_756148903743808_2814964879460395130_n.jpg',
    likes: 1842,
    comments: 328,
    time: '3h ago',
    locked: false,
    location: 'Rating Studio',
    hashtags: ['#PicRating', '#NoFilter', '#HonestFeedback', '#SpicyRating'],
    product: {
      name: 'Spicy Rating Service',
      price: 15,
      description: 'Get your pics rated by Lana herself! 100% private and honest feedback.'
    }
  }, {
    id: 'lana_self_post2',
    user: {
      name: 'Lana',
      username: 'lana_luxe',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg',
      verified: true
    },
    content: "Safety first, pleasure always! 🔒 Don't risk getting caught viewing my content. SinShift VPN keeps your browsing 100% private with zero traces. Use code LANA20 for 20% off! #PrivacyMatters",
    type: 'image',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hRMai31D5YWuFwX2yr3AS7/516505876_770863238939041_5072179375122471885_n.jpg',
    likes: 1253,
    comments: 214,
    time: '5h ago',
    locked: false,
    location: 'Private Lounge',
    hashtags: ['#PrivacyMatters', '#StaySafe', '#NoTraces', '#SinShiftVPN'],
    vpnUpsell: true,
    product: {
      name: 'SinShift VPN',
      price: 29.99,
      discount: 20,
      description: 'Complete privacy protection with zero traces. Browse without worries!'
    }
  }];
  // Daily targets data
  const dailyTargets = [{
    id: 'target1',
    type: 'daily_target',
    title: 'Send a Gift',
    description: 'Send a gift to one of your favorite angels',
    icon: <Gift size={20} className="text-pink-400" data-id="element-5932" />,
    reward: '10 💗',
    progress: 0,
    total: 1,
    completed: false,
    cta: 'Send Gift'
  }, {
    id: 'target2',
    type: 'daily_target',
    title: 'Like 5 Posts',
    description: 'Show some love to your favorite angels',
    icon: <Heart size={20} className="text-pink-400" data-id="element-5933" />,
    reward: '15 💗',
    progress: dailyMissionProgress,
    total: 5,
    completed: false,
    cta: 'Find Posts'
  }, {
    id: 'target3',
    type: 'daily_target',
    title: 'Comment on a Post',
    description: 'Leave a thoughtful comment on any post',
    icon: <MessageCircle size={20} className="text-pink-400" data-id="element-5934" />,
    reward: '20 💗',
    progress: 0,
    total: 1,
    completed: false,
    cta: 'Find Posts'
  }, {
    id: 'target4',
    type: 'daily_target',
    title: 'Watch a Story',
    description: 'Check out what your angels are up to today',
    icon: <Camera size={20} className="text-pink-400" data-id="element-5935" />,
    reward: '5 💗',
    progress: 0,
    total: 1,
    completed: false,
    cta: 'View Stories'
  }, {
    id: 'target5',
    type: 'daily_target',
    title: 'Unlock Premium Content',
    description: 'Experience exclusive content from your angels',
    icon: <Lock size={20} className="text-pink-400" data-id="element-5936" />,
    reward: '1 💎',
    progress: 0,
    total: 1,
    completed: false,
    cta: 'Unlock Content'
  }];
  // Other tabs would have their own post arrays
  const kinksPosts = forYouPosts.filter(post => post.hashtags?.some(tag => ['#lingerie', '#toys', '#control'].includes(tag)));
  const fanClubPosts = forYouPosts.filter(post => post.locked || post.type === 'premium_content');
  const videosPhotosPosts = forYouPosts.filter(post => post.type === 'blur_image' || post.type === 'premium_content');
  const highlightsPosts = forYouPosts.filter(post => post.likes > 200);
  // Following posts data - personalized messages to the customer
  const followingPosts = [{
    id: 'following1',
    user: {
      name: 'Sophia',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
      verified: true
    },
    content: "Just finished my yoga session... feeling so relaxed and energized! 🧘‍♀️ What's everyone up to today?",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uyiXhnExYU79VjyGrEvQrS/masturbate.jpg',
    type: 'public_post',
    likes: 243,
    comments: 42,
    time: '2h ago',
    locked: false,
    location: 'Yoga Studio',
    hashtags: ['#yoga', '#fitness', '#wellness']
  }, {
    id: 'following2',
    user: {
      name: 'Eva',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nBpXopQ7YXWmZqdTwR7HaM/image.png',
      verified: true
    },
    content: "Help me decide what to wear for tonight's photoshoot! 💋",
    type: 'poll',
    likes: 189,
    comments: 56,
    time: '3h ago',
    locked: false,
    location: 'Bedroom',
    poll: {
      options: [{
        text: 'Red lingerie ❤️',
        percentage: 64
      }, {
        text: 'Nothing at all 🖤',
        percentage: 36
      }],
      endsIn: '3 hours'
    },
    hashtags: ['#fashion', '#lingerie', '#decisiontime']
  }, {
    id: 'following3',
    user: {
      name: 'Lana',
      username: 'lana_luxe',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg',
      verified: true
    },
    content: 'Just finished my workout and feeling amazing! 💦 Who else is hitting the gym today?',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wiNDmy3jyz5k1YDhJsw7Zz/509629230_756148903743808_2814964879460395130_n.jpg',
    type: 'public_post',
    likes: 312,
    comments: 78,
    time: '30m ago',
    locked: false,
    location: 'Home Gym',
    hashtags: ['#PostWorkout', '#FitLife', '#HealthyLifestyle']
  }, {
    id: 'following4',
    user: {
      name: 'Bonny Blue',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png',
      verified: true
    },
    content: 'Ready for our gaming session? I got something special for the winners tonight... 🎮💋',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png',
    type: 'premium_content',
    likes: 427,
    comments: 92,
    time: '1h ago',
    locked: true,
    price: 10,
    location: 'Gaming Room',
    hashtags: ['#GamerGirl', '#ExclusiveContent', '#PlayToWin']
  }, {
    id: 'following5',
    user: {
      name: 'Riley',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2myPwGWmEWGW4CWiQgdDdz/image.png',
      verified: true
    },
    content: 'I recorded this just for you... listen with headphones 🎧',
    type: 'audio',
    audioUrl: 'https://assets.mixkit.co/active_storage/sfx/212/212-preview.mp3',
    audioWaveform: [0.2, 0.5, 0.3, 0.8, 0.4, 0.6, 0.3, 0.5, 0.7, 0.8, 0.5, 0.3, 0.6, 0.4, 0.2],
    likes: 312,
    comments: 78,
    time: '4h ago',
    locked: false,
    location: 'Bedroom',
    hashtags: ['#voice', '#asmr', '#intimate']
  }, {
    id: 'following6',
    user: {
      name: 'Kim Holland',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png',
      verified: true
    },
    content: "🔴 GOING LIVE in 15 minutes! I'll be trying on new lingerie and need your help deciding what to keep...",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png',
    type: 'live_announcement',
    likes: 89,
    comments: 24,
    time: '15m ago',
    locked: false,
    liveDetails: {
      startsIn: '15 minutes',
      entryFee: 5,
      rewards: 'Top tippers get a private photo set!'
    },
    hashtags: ['#goingLive', '#lingerie', '#interactive']
  }, {
    id: 'following7',
    user: {
      name: 'Jasmine',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cbRc9jayz6abrUqY99QsFF/pasted-image.jpg',
      verified: true
    },
    content: "I've been thinking about you all day... can't wait to show you what's underneath 💦",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/t1fMgo9T4WadxWeynPJ6vb/videoblur.png',
    type: 'premium_content',
    likes: 427,
    comments: 92,
    time: '5h ago',
    locked: true,
    price: 8,
    location: 'Secret Spot',
    hashtags: ['#exclusive', '#premium', '#justforyou']
  }, {
    id: 'following8',
    user: {
      name: 'Lana',
      username: 'lana_luxe',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg',
      verified: true
    },
    content: "Safety first, pleasure always! 🔒 Don't risk getting caught viewing my content. SinShift VPN keeps your browsing 100% private with zero traces. Use code LANA20 for 20% off! #PrivacyMatters",
    type: 'image',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hRMai31D5YWuFwX2yr3AS7/516505876_770863238939041_5072179375122471885_n.jpg',
    likes: 1253,
    comments: 214,
    time: '5h ago',
    locked: false,
    location: 'Private Lounge',
    hashtags: ['#PrivacyMatters', '#StaySafe', '#NoTraces', '#SinShiftVPN'],
    vpnUpsell: true,
    product: {
      name: 'SinShift VPN',
      price: 29.99,
      discount: 20,
      description: 'Complete privacy protection with zero traces. Browse without worries!'
    }
  }, {
    id: 'following9',
    user: {
      name: 'Harper',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8g53dZ7J3kRR9dJNnGuDbc/h2.png',
      verified: true
    },
    content: 'Ready to play a game? Tell me what you see in these ink blots... 😏',
    type: 'poll',
    likes: 389,
    comments: 76,
    time: '7h ago',
    locked: false,
    location: 'Psychologist Office',
    poll: {
      options: [{
        text: 'A butterfly 🦋',
        percentage: 25
      }, {
        text: 'Two people kissing 💋',
        percentage: 75
      }],
      endsIn: '5 hours'
    },
    hashtags: ['#MindGames', '#WhatDoYouSee', '#Psychology']
  }, {
    id: 'following10',
    user: {
      name: 'GoldenShowerTina',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wE6GWs4adBoQ5FAV8cx8zV/MiaKhalifa.jpg',
      verified: true
    },
    content: 'Want to see what happens next? 💦 Unlock my exclusive shower video...',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wE6GWs4adBoQ5FAV8cx8zV/MiaKhalifa.jpg',
    type: 'premium_content',
    likes: 1827,
    comments: 342,
    time: '2d ago',
    locked: true,
    price: 15,
    location: 'Bathroom',
    hashtags: ['#ShowerTime', '#ExclusiveContent', '#GetWet']
  }];
  // Create forYouPersonalizedPosts array for personalized content directed at the user
  const forYouPersonalizedPosts = [{
    id: 'forYou1',
    user: {
      name: 'Sophia',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
      verified: true
    },
    content: "Hi Mitch! Thanks for your sweet comment on my last photo. I've been thinking about you today... hope you're having a great day! 💋",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uyiXhnExYU79VjyGrEvQrS/masturbate.jpg',
    type: 'personal_message',
    likes: 1,
    comments: 0,
    time: '1h ago',
    locked: false,
    location: 'Private Message',
    hashtags: ['#JustForYou', '#SpecialConnection']
  }, {
    id: 'forYou2',
    user: {
      name: 'Eva',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nBpXopQ7YXWmZqdTwR7HaM/image.png',
      verified: true
    },
    content: 'Mitch, I saw you liked my lingerie poll! I went with the red one just for you... check your DMs later for a special preview 😘',
    type: 'personal_message',
    likes: 1,
    comments: 0,
    time: '3h ago',
    locked: false,
    location: 'Private Message',
    hashtags: ['#JustForYou', '#PrivateShow']
  }, {
    id: 'forYou3',
    user: {
      name: 'Lana',
      username: 'lana_luxe',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg',
      verified: true
    },
    content: "Just finished my workout and thought of you, Mitch! Your support means everything to me. Here's a little post-workout glow just for my favorite fan 💦",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wiNDmy3jyz5k1YDhJsw7Zz/509629230_756148903743808_2814964879460395130_n.jpg',
    type: 'personal_message',
    likes: 1,
    comments: 0,
    time: '30m ago',
    locked: false,
    location: 'Home Gym',
    hashtags: ['#PostWorkout', '#JustForYou', '#YourFavorite']
  }, {
    id: 'forYou4',
    user: {
      name: 'Sophia',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
      verified: true
    },
    content: "Taking requests for my next photoshoot! Mitch, you've been such an amazing supporter - what would you like to see? Beach, bedroom, or something more... creative? 😏",
    type: 'request',
    likes: 1,
    comments: 0,
    time: '5h ago',
    locked: false,
    location: 'Photo Studio',
    hashtags: ['#YourChoice', '#Requests', '#Photoshoot']
  }, {
    id: 'forYou5',
    user: {
      name: 'Lana',
      username: 'lana_luxe',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg',
      verified: true
    },
    content: "Mitch! Your message made me smile so much. I'm filming a special video tomorrow and your suggestion is definitely going to be part of it. Can't wait for you to see it 💋",
    type: 'personal_message',
    likes: 1,
    comments: 0,
    time: '2h ago',
    locked: false,
    location: 'Private Message',
    hashtags: ['#YourIdea', '#ComingSoon', '#ExclusiveContent']
  }];
  // Mix daily targets into the main feed
  const getMixedFeedPosts = () => {
    const posts = [...forYouPosts];
    // Insert all 5 daily targets at specific positions throughout the feed
    posts.splice(2, 0, dailyTargets[0]);
    posts.splice(5, 0, dailyTargets[1]);
    posts.splice(8, 0, dailyTargets[2]);
    posts.splice(11, 0, dailyTargets[3]);
    posts.splice(14, 0, dailyTargets[4]);
    return posts;
  };
  const arVrPosts = [{
    id: 'ar1',
    user: {
      name: 'Sophia',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
      verified: true
    },
    content: 'Experience our beach date in 360° - move your phone to look around 🏖️',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9ia5ocpPYaJTgz8NebPpjC/image.png',
    type: 'ar_content',
    likes: 342,
    comments: 87,
    time: '2d ago',
    locked: false,
    arDetails: {
      type: '360',
      instruction: 'Move your device to look around'
    },
    hashtags: ['#VR', '#360', '#immersive']
  }];
  // Inside the CustomerProfile component, add new components to the renderContent function
  const renderContent = () => {
    if (activeTab === 'dickpicRating') {
      return <div className="flex items-center justify-center py-8" data-id="element-5937">
          <DickpicRatingUpsell onClose={() => setActiveTab('forYou')} onSelect={(tier, price) => {
          // Handle tier selection
          console.log(`Selected tier ${tier} for ${price} tokens`);
          // Close modal and return to feed
          setActiveTab('forYou');
        }} data-id="element-5938" />
        </div>;
    }
    switch (activeTab) {
      case 'forYou':
        return forYouPersonalizedPosts;
      case 'following':
        // Merge personalized posts with following posts to show them in both tabs
        // Sort by time to ensure proper chronological order
        const mergedFollowingPosts = [...followingPosts, ...forYouPersonalizedPosts].sort((a, b) => {
          // Convert time strings like "2h ago" to numbers for sorting
          // Higher number = more recent
          const getTimeValue = (time: string) => {
            if (time.includes('m')) return parseInt(time) * 60;
            if (time.includes('h')) return parseInt(time) * 3600;
            if (time.includes('d')) return parseInt(time) * 86400;
            return 0;
          };
          const timeA = getTimeValue(a.time);
          const timeB = getTimeValue(b.time);
          return timeB - timeA; // Sort in descending order (newest first)
        });
        return mergedFollowingPosts;
      case 'kinks':
        return kinksPosts;
      case 'polls':
        return forYouPosts.filter(post => post.type === 'poll');
      case 'fanClub':
        return fanClubPosts;
      case 'videosPhotos':
        return videosPhotosPosts;
      case 'highlights':
        return highlightsPosts;
      case 'dailyTargets':
        return dailyTargets;
      case 'arVr':
        return showARMode ? arVrPosts : forYouPosts;
      case 'memory':
        return <MemoryEngine data-id="element-5939" />;
      case 'emotionalBond':
        return <EmotionalBondMeter data-id="element-5940" />;
      case 'relationshipTracker':
        return <RelationshipTracker data-id="element-5941" />;
      case 'voiceAI':
        return <VoiceAILayer data-id="element-5942" />;
      case 'multiChat':
        return <MultiAngelGroupChat data-id="element-5943" />;
      default:
        return forYouPosts;
    }
  };
  // Function to scroll the navbar horizontally
  const scrollNavBar = (direction: 'left' | 'right') => {
    if (navBarRef.current) {
      const scrollAmount = direction === 'left' ? -200 : 200;
      navBarRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  // Track profile view
  useEffect(() => {
    trackProductView('customer_profile', 'profile_page');
  }, []);
  // Handle clicks outside of menus
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setActiveMenu(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  // Clean up audio when component unmounts
  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
      }
    };
  }, []);
  // Add an event listener to handle navigation to Lana's feed
  useEffect(() => {
    const handleNavigateToLana = () => {
      if (onNavigate) {
        // Set Lana's ID (11) as selected angel ID and show her feed
        onNavigate('discover');
        setTimeout(() => {
          const lanaElement = document.querySelector('[data-angel-id="11"]');
          if (lanaElement) {
            lanaElement.click();
          }
        }, 100);
      }
    };
    document.addEventListener('navigateToLana', handleNavigateToLana);
    return () => {
      document.removeEventListener('navigateToLana', handleNavigateToLana);
    };
  }, [onNavigate]);
  // Add viewport size detection
  useEffect(() => {
    const handleResize = () => {
      setViewportWidth(window.innerWidth);
      setImageQuality(window.innerWidth > 1200 ? 'high' : window.innerWidth > 768 ? 'medium' : 'low');
    };
    window.addEventListener('resize', handleResize);
    // Set up ResizeObserver for post container width
    if (postContainerRef.current && window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          const width = entry.contentRect.width;
          // Adjust image quality based on container width
          if (width > 820) {
            setImageQuality('high');
          } else if (width > 640) {
            setImageQuality('medium');
          } else {
            setImageQuality('low');
          }
        }
      });
      resizeObserver.observe(postContainerRef.current);
      return () => {
        resizeObserver.disconnect();
        window.removeEventListener('resize', handleResize);
      };
    }
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const getActivePosts = () => {
    switch (activeTab) {
      case 'forYou':
        return forYouPersonalizedPosts;
      case 'following':
        return followingPosts;
      case 'fanClub':
        return fanClubPosts;
      case 'videosPhotos':
        return videosPhotosPosts;
      case 'highlights':
        return highlightsPosts;
      default:
        return forYouPosts;
    }
  };
  const toggleLike = (postId: string) => {
    setLikedPosts(prev => {
      const newState = {
        ...prev,
        [postId]: !prev[postId]
      };
      // Update daily mission progress if this is a new like
      if (!prev[postId] && dailyMissionProgress < 3) {
        setDailyMissionProgress(prev => prev + 1);
      }
      // Show XP earned animation
      if (!prev[postId]) {
        setXpEarned({
          id: postId,
          value: 1
        });
        setTimeout(() => setXpEarned(null), 1500);
      }
      return newState;
    });
  };
  const handleUnlock = (postId: string) => {
    setUnlockPostId(postId);
    setShowUnlockModal(true);
  };
  const confirmUnlock = () => {
    // Here you would handle the actual token transaction
    setShowUnlockModal(false);
    // For demo purposes, we'll just mark the post as unlocked
    const posts = getActivePosts();
    const post = posts.find(p => p.id === unlockPostId);
    if (post) {
      post.locked = false;
    }
  };
  const handleTip = (postId: string) => {
    setTipPostId(postId);
    setShowTipOptions(true);
  };
  const sendTip = (amount: number) => {
    // Here you would handle the actual token transaction
    setShowTipOptions(false);
    // Show XP earned animation
    setXpEarned({
      id: tipPostId!,
      value: 5
    });
    setTimeout(() => setXpEarned(null), 1500);
  };
  const toggleAudio = (postId: string) => {
    if (isPlaying === postId) {
      audioRef.current?.pause();
      setIsPlaying(null);
    } else {
      if (audioRef.current) {
        audioRef.current.src = forYouPosts.find(p => p.id === postId)?.audioUrl || '';
        audioRef.current.play();
        setIsPlaying(postId);
      }
    }
  };
  const toggleARMode = () => {
    setShowARMode(!showARMode);
    setActiveTab('arVr');
  };
  const toggleMenu = (postId: string, event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    // Toggle the active menu - close if already open, open if closed
    setActiveMenu(prevActiveMenu => prevActiveMenu === postId ? null : postId);
  };
  const renderPostMenu = (postId: string) => {
    if (activeMenu !== postId) return null;
    return <div className="absolute top-12 right-3 w-72 bg-gray-900 rounded-xl border border-gray-800 shadow-xl overflow-auto animate-in fade-in zoom-in-95 duration-200 z-30" onClick={e => e.stopPropagation()} ref={menuRef} data-id="element-5944">
        {/* Menu Header with Close Button */}
        <div className="sticky top-0 z-10 flex items-center justify-between p-3 border-b border-gray-800 bg-gray-900" data-id="element-5945">
          <span className="font-medium" data-id="element-5946">Options</span>
          <button className="p-1 rounded-full hover:bg-gray-800" onClick={e => {
          e.stopPropagation();
          setActiveMenu(null);
        }} data-id="element-5947">
            <X size={16} data-id="element-5948" />
          </button>
        </div>
        {/* Main Actions */}
        <div className="border-b border-gray-800" data-id="element-5949">
          <button className="w-full px-4 py-3 text-left text-sm hover:bg-gray-800/50 flex items-center gap-3" data-id="element-5950">
            <Heart size={18} className="text-pink-400" data-id="element-5951" />
            <span data-id="element-5952">Follow</span>
          </button>
          <button className="w-full px-4 py-3 text-left text-sm hover:bg-gray-800/50 flex items-center gap-3" data-id="element-5953">
            <MessageCircle size={18} data-id="element-5954" />
            <span data-id="element-5955">Message</span>
          </button>
          <button className="w-full px-4 py-3 text-left text-sm hover:bg-gray-800/50 flex items-center gap-3" data-id="element-5956">
            <Gift size={18} data-id="element-5957" />
            <span data-id="element-5958">Send Gift</span>
            <span className="ml-auto text-xs text-pink-400" data-id="element-5959">💗 Tokens</span>
          </button>
        </div>
        {/* Premium Opportunities Section */}
        <div className="border-b border-gray-800" data-id="element-5960">
          <div className="px-4 py-2" data-id="element-5961">
            <p className="text-xs text-gray-500 uppercase font-medium" data-id="element-5962">
              PREMIUM OPPORTUNITIES
            </p>
          </div>
          {/* Subscribe to exclusive content */}
          <div className="relative px-4 py-2" data-id="element-5963">
            <button className="w-full flex items-center gap-3 px-3 py-3 text-left text-sm rounded-lg bg-gradient-to-r from-purple-900/40 to-pink-900/40 hover:from-purple-900/60 hover:to-pink-900/60 transition-colors" data-id="element-5964">
              <Crown size={18} className="text-yellow-400" data-id="element-5965" />
              <div className="flex-1" data-id="element-5966">
                <span data-id="element-5967">Subscribe to exclusive content</span>
                <p className="text-xs text-gray-400 mt-0.5" data-id="element-5968">
                  Unlock all premium content
                </p>
              </div>
              <div className="flex items-center" data-id="element-5969">
                <span className="text-purple-400 font-medium" data-id="element-5970">💎</span>
                <span className="ml-1 text-white" data-id="element-5971">15</span>
              </div>
            </button>
            <div className="absolute -top-1 -right-1 px-2 py-0.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-xs font-medium transform rotate-3" data-id="element-5972">
              Special Offer
            </div>
          </div>
          {/* Unlock private content */}
          <button className="w-full flex items-center gap-3 px-4 py-3 text-left text-sm hover:bg-gray-800/50 transition-colors" data-id="element-5973">
            <Lock size={18} className="text-pink-400" data-id="element-5974" />
            <span className="flex-1" data-id="element-5975">Unlock private content</span>
            <div className="flex items-center" data-id="element-5976">
              <span className="text-blue-400 font-medium" data-id="element-5977">💎</span>
              <span className="ml-1 text-white" data-id="element-5978">10</span>
            </div>
          </button>
          {/* Request custom content */}
          <button className="w-full flex items-center gap-3 px-4 py-3 text-left text-sm hover:bg-gray-800/50 transition-colors" data-id="element-5979">
            <Camera size={18} className="text-pink-400" data-id="element-5980" />
            <span className="flex-1" data-id="element-5981">Request custom content</span>
            <div className="flex items-center" data-id="element-5982">
              <span className="text-blue-400 font-medium" data-id="element-5983">💎</span>
              <span className="ml-1 text-white" data-id="element-5984">25+</span>
            </div>
          </button>
          {/* 50% off all premium content */}
          <div className="px-4 py-2 mx-4 my-2 bg-gray-800/50 rounded-lg flex items-center" data-id="element-5985">
            <Sparkles size={16} className="text-yellow-400 mr-2" data-id="element-5986" />
            <div className="flex-1" data-id="element-5987">
              <span className="text-xs" data-id="element-5988">50% off all premium content</span>
              <div className="flex items-center gap-1 text-xs text-gray-400" data-id="element-5989">
                <Clock size={12} data-id="element-5990" />
                <span data-id="element-5991">
                  Ends in {timeLeft.hours}h {timeLeft.minutes}m
                </span>
              </div>
            </div>
            <ChevronRight size={14} className="text-gray-400" data-id="element-5992" />
          </div>
        </div>
        {/* Standard Options */}
        <div className="p-2" data-id="element-5993">
          <div className="grid grid-cols-2 gap-2" data-id="element-5994">
            <button className="p-3 bg-gray-800 rounded-lg flex items-center gap-2 hover:bg-gray-700 transition-colors" data-id="element-5995">
              <ListPlus size={18} className="text-gray-400" data-id="element-5996" />
              <span className="text-sm" data-id="element-5997">Add to List</span>
            </button>
            <button className="p-3 bg-gray-800 rounded-lg flex items-center gap-2 hover:bg-gray-700 transition-colors" data-id="element-5998">
              <BellOff size={18} className="text-gray-400" data-id="element-5999" />
              <span className="text-sm" data-id="element-6000">Mute</span>
            </button>
            <button className="p-3 bg-gray-800 rounded-lg flex items-center gap-2 hover:bg-gray-700 transition-colors" data-id="element-6001">
              <Share2 size={18} className="text-gray-400" data-id="element-6002" />
              <span className="text-sm" data-id="element-6003">Share</span>
            </button>
            <button className="p-3 bg-gray-800 rounded-lg flex items-center gap-2 hover:bg-gray-700 transition-colors" data-id="element-6004">
              <Flag size={18} className="text-gray-400" data-id="element-6005" />
              <span className="text-sm" data-id="element-6006">Report</span>
            </button>
          </div>
        </div>
      </div>;
  };
  const renderPost = (post: any) => {
    // Handle daily target rendering with the new glassmorphism design
    if (post.type === 'daily_target') {
      return <div key={post.id} className="p-3 my-3 mx-2 bg-white/5 dark:bg-white/5 backdrop-filter backdrop-blur-md border border-white/8 dark:border-white/8 rounded-2xl shadow-none animate-in fade-in duration-500" data-id="element-6007">
          <div className="flex items-center gap-2" data-id="element-6008">
            <div className="w-7 h-7 flex items-center justify-center bg-pink-500/5 dark:bg-pink-500/5 rounded-full overflow-hidden" data-id="element-6009">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5sbpAJjidppECYHoqB8bWs/SinShift_logo.png" alt="SinShift" className="w-5 h-5 object-contain opacity-80" data-id="element-6010" />
            </div>
            <div className="flex-grow" data-id="element-6011">
              <h3 className="text-sm font-normal text-gray-600 dark:text-gray-400" data-id="element-6012">
                Daily Mission
              </h3>
              <div className="mt-1 h-1 bg-white/10 dark:bg-white/10 rounded-full overflow-hidden" data-id="element-6013">
                <div className="h-full bg-gradient-to-r from-pink-300/50 to-purple-300/50 rounded-full transition-all duration-300" style={{
                width: `${dailyMissionProgress / 3 * 100}%`
              }} data-id="element-6014"></div>
              </div>
              <div className="flex items-center justify-between mt-1" data-id="element-6015">
                <span className="text-xs text-gray-500 dark:text-gray-500" data-id="element-6016">
                  Like posts to earn gems
                </span>
                <span className="text-xs text-pink-400/70" data-id="element-6017">
                  {dailyMissionProgress}/3
                </span>
              </div>
            </div>
          </div>
        </div>;
    }
    // Add video upsell after post5
    if (post.id === 'post5') {
      return <Fragment key={post.id} data-id="element-6018">
          {renderRegularPost(post)}
          {/* Add discreet image generation upsell */}
          <div className="mb-4 px-3" onClick={() => setShowImageGeneratorModal(true)} data-id="element-6019">
            <ImageGenerationUpsell discreet={true} data-id="element-6020" />
          </div>
          {/* Add discreet video generation upsell */}
          <div className="mb-4 px-3" onClick={() => setShowVideoUpsellModal(true)} data-id="element-6021">
            <VideoGenerationUpsell discreet={true} data-id="element-6022" />
          </div>
        </Fragment>;
    }
    {
      post.type === 'product_recommendation' && <div className="mt-3" data-id="element-6023">
          <div className="bg-gradient-to-r from-blue-900/20 to-purple-900/20 rounded-lg border border-blue-800/40 p-3" data-id="element-6024">
            <div className="flex gap-3" data-id="element-6025">
              <div className="w-20 h-20 bg-gray-800 rounded-md overflow-hidden" data-id="element-6026">
                <img src={post.product.image} alt={post.product.name} className="w-full h-full object-cover" data-id="element-6027" />
              </div>
              <div className="flex-1" data-id="element-6028">
                <div className="flex items-center gap-1" data-id="element-6029">
                  <h4 className="text-sm font-medium" data-id="element-6030">{post.product.name}</h4>
                  {post.product.rating && <div className="flex items-center ml-1" data-id="element-6031">
                      <span className="text-yellow-400 text-xs" data-id="element-6032">★</span>
                      <span className="text-xs text-gray-300 ml-0.5" data-id="element-6033">
                        {post.product.rating}
                      </span>
                    </div>}
                </div>
                <p className="text-xs text-gray-300 line-clamp-2 mt-0.5" data-id="element-6034">
                  {post.product.description}
                </p>
                {post.product.reviewCount && <p className="text-xs text-gray-400 mt-1" data-id="element-6035">
                    {post.product.reviewCount} verified reviews
                  </p>}
                <div className="flex items-center justify-between mt-2" data-id="element-6036">
                  <div className="flex items-baseline gap-1" data-id="element-6037">
                    <span className="text-sm font-bold" data-id="element-6038">
                      $
                      {(post.product.price * (100 - (post.product.discount || 0)) / 100).toFixed(2)}
                    </span>
                    {post.product.discount > 0 && <span className="text-xs text-gray-400 line-through" data-id="element-6039">
                        ${post.product.price.toFixed(2)}
                      </span>}
                    {post.product.discount > 0 && <span className="text-xs bg-green-600 text-white px-1.5 py-0.5 rounded" data-id="element-6040">
                        {post.product.discount}% OFF
                      </span>}
                  </div>
                  <button className="px-3 py-1.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-xs font-medium" data-id="element-6041">
                    Shop Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>;
    }
    // Add personalized recommendations after the third post in the For You tab
    if (post.id === 'post3' && activeTab === 'forYou' && showRecommendations) {
      return <Fragment key={post.id} data-id="element-6042">
          {renderRegularPost(post)}
          {/* Add discreet image generation upsell */}
          <div className="mb-4 px-3" onClick={() => setShowImageGeneratorModal(true)} data-id="element-6043">
            <ImageGenerationUpsell discreet={true} data-id="element-6044" />
          </div>
          {/* Add discreet video generation upsell */}
          <div className="mb-4 px-3" onClick={() => setShowVideoUpsellModal(true)} data-id="element-6045">
            <VideoGenerationUpsell discreet={true} data-id="element-6046" />
          </div>
        </Fragment>;
    }
    return renderRegularPost(post);
  };
  // Extract the regular post rendering logic
  const renderRegularPost = (post: any) => {
    return <div key={post.id} className="border-b border-gray-800 relative animate-in fade-in duration-300" ref={postContainerRef} data-id="element-6047">
        <div className="p-3 flex gap-3" data-id="element-6048">
          <div className="flex-shrink-0" data-id="element-6049">
            <div className="w-10 h-10 rounded-full overflow-hidden border border-gray-700" data-id="element-6050">
              {/* Use ResponsiveImage for avatar */}
              <ResponsiveImage src={post.user.avatar} alt={`${post.user.name}'s profile picture`} className="w-full h-full object-cover" aspectRatio="1/1" quality={imageQuality} loadingEffect="blur" priority={true} data-id="element-6051" />
            </div>
          </div>
          <div className="flex-grow" data-id="element-6052">
            <div className="flex items-center justify-between" data-id="element-6053">
              <div data-id="element-6054">
                <div className="flex items-center gap-1" data-id="element-6055">
                  <h3 className="font-medium" data-id="element-6056">
                    {post.user.name === 'Lana' || post.user.username === 'lana_luxe' ? <span className="cursor-pointer text-pink-400 hover:underline" onClick={() => {
                    if (onNavigate) {
                      // Directly set selectedAngelId to 11 (Lana's ID) and show her feed
                      onNavigate('twitter_profile');
                      // Then trigger navigation to Lana's feed via custom event
                      setTimeout(() => {
                        const event = new CustomEvent('selectAngel', {
                          detail: {
                            angelId: '11'
                          }
                        });
                        document.dispatchEvent(event);
                      }, 100);
                    }
                  }} data-id="element-6057">
                        {post.user.name}
                      </span> : post.user.name === 'Sophia' ? <span className="cursor-pointer text-pink-400 hover:underline" onClick={() => {
                    if (onNavigate) {
                      // Directly set selectedAngelId to 1 (Sophia's ID) and show her feed
                      onNavigate('twitter_profile');
                      // Then trigger navigation to Sophia's feed via custom event
                      setTimeout(() => {
                        const event = new CustomEvent('selectAngel', {
                          detail: {
                            angelId: '1'
                          }
                        });
                        document.dispatchEvent(event);
                      }, 100);
                    }
                  }} data-id="element-6058">
                        {post.user.name}
                      </span> : post.user.name}
                  </h3>
                  {post.user.verified && <CheckCircle size={14} className="text-pink-500" fill="currentColor" data-id="element-6059" />}
                  <span className="text-xs text-gray-400" data-id="element-6060">• {post.time}</span>
                </div>
                {post.location && <div className="flex items-center gap-1 text-xs text-gray-400" data-id="element-6061">
                    <MapPin size={10} data-id="element-6062" />
                    <span data-id="element-6063">{post.location}</span>
                  </div>}
              </div>
              <button className="p-2 hover:bg-gray-800 rounded-full" onClick={e => toggleMenu(post.id, e)} data-id="element-6064">
                <MoreHorizontal size={16} className="text-gray-400" data-id="element-6065" />
              </button>
              {renderPostMenu(post.id)}
            </div>
            <div className="mt-2" data-id="element-6066">
              <p className="text-sm" data-id="element-6067">
                {post.content.includes('@lana_luxe') ? <>
                    {post.content.split('@lana_luxe').map((part, i, arr) => <Fragment key={i} data-id="element-6068">
                        {part}
                        {i < arr.length - 1 && <span className="text-pink-400 font-medium cursor-pointer" onClick={() => {
                    if (onNavigate) {
                      // Directly set selectedAngelId to 11 (Lana's ID) and show her feed
                      onNavigate('twitter_profile');
                      // Then trigger navigation to Lana's feed via custom event
                      setTimeout(() => {
                        const event = new CustomEvent('selectAngel', {
                          detail: {
                            angelId: '11'
                          }
                        });
                        document.dispatchEvent(event);
                      }, 100);
                    }
                  }} data-id="element-6069">
                            @lana_luxe
                          </span>}
                      </Fragment>)}
                  </> : post.content.includes('<span') ?
              // Handle posts with HTML/JSX content that include onNavigate
              <span dangerouslySetInnerHTML={{
                __html: post.content.replace(/<span class='text-pink-400 font-medium cursor-pointer' onClick={\(\) => onNavigate && onNavigate\('twitter_profile'\)}>@lana_luxe<\/span>/g, `<span class='text-pink-400 font-medium cursor-pointer' onclick="document.dispatchEvent(new CustomEvent('selectAngel', { detail: { angelId: '11' } }))">@lana_luxe</span>`)
              }} data-id="element-6070" /> : post.content}
              </p>
              {post.hashtags && <div className="flex flex-wrap gap-1 mt-1" data-id="element-6071">
                  {post.hashtags.map((tag: string, i: number) => <span key={i} className="text-xs text-pink-400" data-id="element-6072">
                      {tag}
                    </span>)}
                </div>}
            </div>
            {/* VPN Upsell */}
            {post.vpnUpsell && <div className="mt-3 p-3 bg-gradient-to-r from-blue-900/30 to-purple-900/30 rounded-lg border border-blue-800/30" data-id="element-6073">
                <div className="flex items-center gap-2" data-id="element-6074">
                  <div className="w-8 h-8 flex items-center justify-center bg-blue-500/20 rounded-full text-blue-400" data-id="element-6075">
                    <Shield size={16} data-id="element-6076" />
                  </div>
                  <div className="flex-1" data-id="element-6077">
                    <p className="text-xs text-gray-300" data-id="element-6078">
                      👀 Don't let your Angel adventures show up at home. Use
                      SinShift VPN for full privacy. Zero traces, total freedom.
                    </p>
                  </div>
                </div>
                <button className="mt-2 w-full py-1.5 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full text-white text-xs font-medium" data-id="element-6079">
                  Activate SinShift VPN 🔒 (Recommended)
                </button>
              </div>}
            {/* Post Content based on type - ENHANCED IMAGE RENDERING */}
            {post.type === 'blur_image' && <div className="mt-3 rounded-lg overflow-hidden post-image-container" data-id="element-6080">
                <picture data-id="element-6081">
                  <source media="(min-width: 1200px)" srcSet={`${post.image}?w=1200 1200w, ${post.image}?w=1600 1600w`} sizes="(min-width: 1200px) 1200px, 100vw" data-id="element-6082" />
                  <source media="(min-width: 768px)" srcSet={`${post.image}?w=800 800w, ${post.image}?w=1200 1200w`} sizes="(min-width: 768px) 800px, 100vw" data-id="element-6083" />
                  <ResponsiveImage src={post.image} alt={`Post by ${post.user.name}: ${post.content.substring(0, 50)}${post.content.length > 50 ? '...' : ''}`} className="w-full object-cover post-image" aspectRatio="16/9" quality={imageQuality} loadingEffect="blur" sizes="(max-width: 640px) 100vw, (max-width: 1024px) 800px, 1200px" data-id="element-6084" />
                </picture>
              </div>}
            {post.type === 'poll' && <div className="mt-3 space-y-2" data-id="element-6085">
                {post.poll.options.map((option: any, i: number) => <button key={i} className="w-full p-3 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-pink-500 dark:hover:border-pink-500 transition flex justify-between items-center" data-id="element-6086">
                    <span className="text-gray-800 dark:text-gray-200" data-id="element-6087">
                      {option.text}
                    </span>
                    <span className="text-xs bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded-full text-gray-700 dark:text-gray-300" data-id="element-6088">
                      {option.percentage}%
                    </span>
                  </button>)}
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1" data-id="element-6089">
                  Voting ends in {post.poll.endsIn} • Results will shape
                  tomorrow's content
                </p>
              </div>}
            {post.type === 'audio' && <div className="mt-3 p-3 bg-gray-800 rounded-lg border border-gray-700" data-id="element-6090">
                <div className="flex items-center gap-3" data-id="element-6091">
                  <button className={`w-10 h-10 flex items-center justify-center rounded-full ${isPlaying === post.id ? 'bg-pink-500 text-white' : 'bg-gray-700 text-gray-300'}`} onClick={() => toggleAudio(post.id)} data-id="element-6092">
                    {isPlaying === post.id ? <div className="w-3 h-3 bg-white rounded-sm" data-id="element-6093"></div> : <Play size={18} fill="currentColor" className="ml-1" data-id="element-6094" />}
                  </button>
                  <div className="flex-grow h-10 flex items-center" data-id="element-6095">
                    {post.audioWaveform.map((level: number, i: number) => <div key={i} className={`w-1 mx-0.5 rounded-full ${isPlaying === post.id ? 'bg-gradient-to-t from-pink-500 to-purple-500' : 'bg-gray-600'}`} style={{
                  height: `${level * 32}px`,
                  animation: isPlaying === post.id ? `pulse 0.8s infinite alternate ${i * 0.1}s` : 'none'
                }} data-id="element-6096"></div>)}
                  </div>
                  <div className="flex items-center gap-1 text-xs text-gray-400" data-id="element-6097">
                    <Headphones size={14} data-id="element-6098" />
                    <span data-id="element-6099">0:18</span>
                  </div>
                </div>
                <p className="text-xs text-gray-400 mt-2" data-id="element-6100">
                  🎧 Best experienced with headphones
                </p>
              </div>}
            {post.type === 'premium_content' && <div className="mt-3 relative rounded-lg overflow-hidden post-image-container" data-id="element-6101">
                <picture data-id="element-6102">
                  <source media="(min-width: 1200px)" srcSet={`${post.image}?w=1200&blur=20 1200w, ${post.image}?w=1600&blur=20 1600w`} sizes="(min-width: 1200px) 1200px, 100vw" data-id="element-6103" />
                  <source media="(min-width: 768px)" srcSet={`${post.image}?w=800&blur=20 800w, ${post.image}?w=1200&blur=20 1200w`} sizes="(min-width: 768px) 800px, 100vw" data-id="element-6104" />
                  <ResponsiveImage src={`${post.image}?blur=20`} alt={`Locked premium content by ${post.user.name}`} className="w-full object-cover blur-lg post-image" aspectRatio="16/9" quality={imageQuality} loadingEffect="blur" sizes="(max-width: 640px) 100vw, (max-width: 1024px) 800px, 1200px" data-id="element-6105" />
                </picture>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent flex flex-col justify-end p-4" data-id="element-6106">
                  {post.liveDetails && <>
                      <div className="flex items-center gap-2 mb-2" data-id="element-6107">
                        <div className="flex items-center gap-1 px-2 py-0.5 bg-red-500/80 rounded-full animate-pulse" data-id="element-6108">
                          <span className="w-2 h-2 rounded-full bg-white" data-id="element-6109"></span>
                          <span className="text-xs font-medium" data-id="element-6110">LIVE SOON</span>
                        </div>
                        <span className="text-xs text-gray-300" data-id="element-6111">
                          Starts in {post.liveDetails.startsIn}
                        </span>
                      </div>
                      <button className="w-full py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white text-sm font-medium" data-id="element-6112">
                        Remind Me
                      </button>
                      <p className="text-xs text-gray-300 mt-2 text-center" data-id="element-6113">
                        {post.liveDetails.rewards}
                      </p>
                    </>}
                  {!post.liveDetails && <>
                      <button className="w-full py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white text-sm font-medium" data-id="element-6114">
                        Unlock Content ({post.price} 💎)
                      </button>
                    </>}
                </div>
              </div>}
            {post.type === 'confession' && <div className="mt-3 p-4 bg-gradient-to-r from-pink-900/20 to-purple-900/20 rounded-lg border border-pink-800/30" data-id="element-6115">
                <div className="flex items-center gap-2 mb-2" data-id="element-6116">
                  <span className="text-pink-400 text-lg" data-id="element-6117">💭</span>
                  <span className="font-medium italic" data-id="element-6118">Confession</span>
                </div>
              </div>}
            {post.type === 'live_announcement' && <div className="mt-3 relative rounded-lg overflow-hidden post-image-container" data-id="element-6119">
                <picture data-id="element-6120">
                  <source media="(min-width: 1200px)" srcSet={`${post.image}?w=1200 1200w, ${post.image}?w=1600 1600w`} sizes="(min-width: 1200px) 1200px, 100vw" data-id="element-6121" />
                  <source media="(min-width: 768px)" srcSet={`${post.image}?w=800 800w, ${post.image}?w=1200 1200w`} sizes="(min-width: 768px) 800px, 100vw" data-id="element-6122" />
                  <ResponsiveImage src={post.image} alt={`Live announcement by ${post.user.name}`} className="w-full object-cover post-image" aspectRatio="16/9" quality={imageQuality} loadingEffect="blur" sizes="(max-width: 640px) 100vw, (max-width: 1024px) 800px, 1200px" data-id="element-6123" />
                </picture>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent flex flex-col justify-end p-4" data-id="element-6124">
                  <div className="flex items-center gap-2 mb-2" data-id="element-6125">
                    <div className="flex items-center gap-1 px-2 py-0.5 bg-red-500/80 rounded-full animate-pulse" data-id="element-6126">
                      <span className="w-2 h-2 rounded-full bg-white" data-id="element-6127"></span>
                      <span className="text-xs font-medium" data-id="element-6128">LIVE SOON</span>
                    </div>
                    <span className="text-xs text-gray-300" data-id="element-6129">
                      Starts in {post.liveDetails.startsIn}
                    </span>
                  </div>
                  <button className="w-full py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white text-sm font-medium" data-id="element-6130">
                    Remind Me
                  </button>
                  <p className="text-xs text-gray-300 mt-2 text-center" data-id="element-6131">
                    {post.liveDetails.rewards}
                  </p>
                </div>
              </div>}
            {post.type === 'product_promo' && <div className="mt-3" data-id="element-6132">
                <div className="relative rounded-lg overflow-hidden post-image-container" data-id="element-6133">
                  <picture data-id="element-6134">
                    <source media="(min-width: 1200px)" srcSet={`${post.image}?w=1200 1200w, ${post.image}?w=1600 1600w`} sizes="(min-width: 1200px) 1200px, 100vw" data-id="element-6135" />
                    <source media="(min-width: 768px)" srcSet={`${post.image}?w=800 800w, ${post.image}?w=1200 1200w`} sizes="(min-width: 768px) 800px, 100vw" data-id="element-6136" />
                    <ResponsiveImage src={post.image} alt={`${post.product.name}: ${post.product.description}`} className="w-full object-cover post-image" aspectRatio="16/9" quality={imageQuality} loadingEffect="blur" sizes="(max-width: 640px) 100vw, (max-width: 1024px) 800px, 1200px" data-id="element-6137" />
                  </picture>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3" data-id="element-6138">
                    <div className="flex items-center justify-between" data-id="element-6139">
                      <div data-id="element-6140">
                        <h4 className="font-medium text-sm" data-id="element-6141">
                          {post.product.name}
                        </h4>
                        <p className="text-xs text-gray-300" data-id="element-6142">
                          {post.product.description}
                        </p>
                      </div>
                      <button className="px-3 py-1.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-xs font-medium" data-id="element-6143">
                        Try Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>}
            {post.type === 'mini_game' && <div className="mt-3 p-4 bg-gradient-to-r from-purple-900/30 to-blue-900/30 rounded-lg border border-purple-800/30" data-id="element-6144">
                <div className="flex items-center justify-between mb-3" data-id="element-6145">
                  <div className="flex items-center gap-2" data-id="element-6146">
                    <span className="text-purple-400 text-lg" data-id="element-6147">🎲</span>
                    <span className="font-medium" data-id="element-6148">Lucky Dice</span>
                  </div>
                  <span className="text-xs text-gray-400" data-id="element-6149">Win prizes!</span>
                </div>
                <div className="flex justify-center mb-3" data-id="element-6150">
                  <div className="w-16 h-16 bg-gray-800 rounded-lg flex items-center justify-center text-2xl font-bold shadow-inner" data-id="element-6151">
                    4
                  </div>
                </div>
                <button className="w-full py-2 bg-gradient-to-r from-purple-600 to-blue-600 rounded-lg text-white text-sm font-medium hover:shadow-lg hover:shadow-purple-500/20 transition-all duration-300" data-id="element-6152">
                  Roll Again
                </button>
                <p className="text-xs text-center text-gray-400 mt-2" data-id="element-6153">
                  You won: 5 LuvTokens! 🎉
                </p>
              </div>}
            {post.type === 'ar_content' && <div className="mt-3 relative rounded-lg overflow-hidden post-image-container" data-id="element-6154">
                <picture data-id="element-6155">
                  <source media="(min-width: 1200px)" srcSet={`${post.image}?w=1200 1200w, ${post.image}?w=1600 1600w`} sizes="(min-width: 1200px) 1200px, 100vw" data-id="element-6156" />
                  <source media="(min-width: 768px)" srcSet={`${post.image}?w=800 800w, ${post.image}?w=1200 1200w`} sizes="(min-width: 768px) 800px, 100vw" data-id="element-6157" />
                  <ResponsiveImage src={post.image} alt={`AR experience: ${post.arDetails.instruction}`} className="w-full object-cover post-image" aspectRatio="16/9" quality={imageQuality} loadingEffect="blur" sizes="(max-width: 640px) 100vw, (max-width: 1024px) 800px, 1200px" data-id="element-6158" />
                </picture>
                <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/30 backdrop-blur-sm" data-id="element-6159">
                  <div className="flex items-center gap-2 mb-2" data-id="element-6160">
                    <span className="text-white text-lg" data-id="element-6161">🔄</span>
                    <span className="font-medium text-white" data-id="element-6162">
                      360° Experience
                    </span>
                  </div>
                  <p className="text-sm text-center text-white mb-3" data-id="element-6163">
                    {post.arDetails.instruction}
                  </p>
                  <button className="px-4 py-2 bg-gradient-to-r from-blue-600 to-cyan-600 rounded-full text-white text-sm font-medium" data-id="element-6164">
                    Enter Experience
                  </button>
                </div>
              </div>}
            {/* Post Actions */}
            <div className="mt-3 flex items-center justify-between" data-id="element-6165">
              <div className="flex items-center gap-4" data-id="element-6166">
                <button className="flex items-center gap-1 group relative" onClick={() => toggleLike(post.id)} data-id="element-6167">
                  <Heart size={18} className={likedPosts[post.id] ? 'text-pink-500 fill-pink-500' : 'text-gray-400 group-hover:text-pink-400'} data-id="element-6168" />
                  <span className="text-xs" data-id="element-6169">
                    {likedPosts[post.id] ? post.likes + 1 : post.likes}
                  </span>
                  {/* XP Animation */}
                  {xpEarned && xpEarned.id === post.id && <span className="absolute -top-6 left-0 text-xs text-pink-400 font-medium animate-float-up" data-id="element-6170">
                      +{xpEarned.value} XP
                    </span>}
                </button>
                <button className="flex items-center gap-1" data-id="element-6171">
                  <MessageCircle size={18} className="text-gray-400" data-id="element-6172" />
                  <span className="text-xs" data-id="element-6173">{post.comments}</span>
                </button>
                <button className="flex items-center gap-1" data-id="element-6174">
                  <Share2 size={18} className="text-gray-400" data-id="element-6175" />
                </button>
              </div>
              <div className="flex items-center gap-3" data-id="element-6176">
                <button className="flex items-center gap-1 relative" onClick={() => handleTip(post.id)} data-id="element-6177">
                  <Gift size={18} className="text-purple-400" data-id="element-6178" />
                  <span className="text-xs" data-id="element-6179">Tip</span>
                </button>
                <button className="flex items-center gap-1" data-id="element-6180">
                  <Bookmark size={18} className="text-gray-400" data-id="element-6181" />
                </button>
              </div>
            </div>
            {/* Top Tippers */}
            {post.topTippers && post.topTippers.length > 0 && <div className="mt-2 p-2 bg-gray-900/50 rounded-lg" data-id="element-6182">
                <div className="flex items-center gap-1 mb-1" data-id="element-6183">
                  <Trophy size={14} className="text-yellow-400" data-id="element-6184" />
                  <span className="text-xs text-gray-300" data-id="element-6185">Top Fans:</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-6186">
                  {post.topTippers.map((tipper: any, i: number) => <div key={i} className="flex items-center gap-1 text-xs" data-id="element-6187">
                      <span className="text-gray-300" data-id="element-6188">@{tipper.name}</span>
                      <span className="text-purple-400" data-id="element-6189">{tipper.amount}💎</span>
                      {i < post.topTippers.length - 1 && <span className="text-gray-600" data-id="element-6190">•</span>}
                    </div>)}
                </div>
              </div>}
          </div>
        </div>
      </div>;
  };
  const handleActionSelect = (action: string) => {
    console.log(`Selected action: ${action}`);
    switch (action) {
      case 'daily_targets':
        setShowDailyTargetsModal(true);
        break;
      case 'dickpic_challenge':
        setShowDickpicRatingModal(true);
        break;
      case 'bond':
        setActiveTab('emotionalBond');
        break;
      case 'relationship':
        setActiveTab('relationshipTracker');
        break;
      case 'kinks_polls':
      case 'social_polls':
        // Implement polls functionality
        break;
      case 'fan_club':
        setActiveTab('fanClub');
        break;
      case 'ar_vr_mode':
        toggleARMode();
        break;
      default:
        break;
    }
  };
  const handleSearchSubmit = () => {
    if (searchQuery.trim()) {
      trackSearchTerm(searchQuery.trim());
    }
  };
  const {
    openQuestionnaire
  } = useQuestionnaire();
  return <div className="w-full max-w-6xl mx-auto bg-white dark:bg-gray-950 text-gray-800 dark:text-white pb-20" data-id="element-6191">
      {/* Debug information */}
      {debugInfo && <div className="fixed top-0 left-0 right-0 bg-red-500 text-white p-2 z-[200] text-sm" data-id="element-6192">
          {debugInfo}
        </div>}

      {/* User Stats Bar */}
      <div className="sticky top-0 z-10 bg-white/90 dark:bg-gray-900/90 backdrop-blur-sm border-b border-gray-200 dark:border-gray-800 px-4 py-2 flex items-center justify-between" data-id="element-6193">
        <div className="flex items-center gap-2" data-id="element-6194">
          <div className="relative" data-id="element-6195">
            <div className="w-8 h-8 rounded-full overflow-hidden" data-id="element-6196"></div>
          </div>
          <div className="flex items-center gap-1" data-id="element-6197">
            <span className="text-pink-500 opacity-80" data-id="element-6198">💗</span>
            <span className="text-xs font-medium text-gray-500 dark:text-gray-400" data-id="element-6199">
              240
            </span>
          </div>
          <div className="flex items-center gap-1" data-id="element-6200">
            <span className="text-purple-500 opacity-80" data-id="element-6201">💎</span>
            <span className="text-xs font-medium text-gray-500 dark:text-gray-400" data-id="element-6202">
              15
            </span>
          </div>
        </div>
        <div className="flex items-center gap-2" data-id="element-6203">
          <button className="flex items-center gap-1 text-xs px-2 py-1 bg-white/5 dark:bg-white/5 backdrop-filter backdrop-blur-md border border-white/10 dark:border-white/5 rounded-full text-gray-500 dark:text-gray-400 hover:bg-white/10 dark:hover:bg-white/10 transition-all" onClick={() => setShowImageGeneratorModal(true)} data-id="element-6204">
            <ImageIcon size={12} className="text-pink-400 opacity-70" data-id="element-6205" />
            <span data-id="element-6206">Generate Image</span>
          </button>
          <button className="flex items-center gap-1 text-xs px-2 py-1 bg-white/5 dark:bg-white/5 backdrop-filter backdrop-blur-md border border-white/10 dark:border-white/5 rounded-full text-gray-500 dark:text-gray-400 hover:bg-white/10 dark:hover:bg-white/10 transition-all" onClick={() => setShowVideoUpsellModal(true)} data-id="element-6207">
            <Video size={12} className="text-pink-400 opacity-70" data-id="element-6208" />
            <span data-id="element-6209">Generate Video</span>
          </button>
        </div>
      </div>
      {/* Daily Progress Widget */}
      <DailyProgressWidget completed={dailyMissionProgress} total={3} onViewTargets={() => setShowDailyTargetsModal(true)} data-id="element-6210" />
      {/* Feed Filter Bar */}
      <FeedFilterBar activeFilter={activeFilter} setActiveFilter={filter => {
      setActiveFilter(filter);
      // Map filter to tab
      switch (filter) {
        case 'for_you':
          setActiveTab('forYou');
          break;
        case 'following':
          setActiveTab('following');
          break;
        case 'highlights':
          setActiveTab('highlights');
          break;
        case 'fan_club':
          setActiveTab('fanClub');
          break;
        case 'media':
          setActiveTab('videosPhotos');
          break;
        case 'memory':
          setActiveTab('memory');
          break;
        default:
          break;
      }
    }} data-id="element-6211" />
      {/* Poll tab intro message - redesigned with glassmorphism */}
      {activeTab === 'polls' && <div className="p-3 bg-white/5 dark:bg-white/5 backdrop-filter backdrop-blur-md border border-white/8 dark:border-white/8 m-4 rounded-2xl shadow-none animate-in fade-in duration-300" data-id="element-6212">
          <div className="flex items-center gap-2 mb-1" data-id="element-6213">
            <span className="text-lg opacity-80" data-id="element-6214">📊</span>
            <h3 className="font-normal text-gray-600 dark:text-gray-400" data-id="element-6215">
              Interactive Polls
            </h3>
          </div>
          <p className="text-xs text-gray-500 dark:text-gray-500 ml-7" data-id="element-6216">
            Vote on your favorite angels' polls and help them decide what
            content to create next.
          </p>
        </div>}
      {/* Highlights tab intro message - redesigned with glassmorphism */}
      {activeTab === 'highlights' && <div className="p-3 bg-white/5 dark:bg-white/5 backdrop-filter backdrop-blur-md border border-white/8 dark:border-white/8 m-4 rounded-2xl shadow-none animate-in fade-in duration-300" data-id="element-6217">
          <div className="flex items-center gap-2 mb-1" data-id="element-6218">
            <span className="text-lg opacity-80" data-id="element-6219">✨</span>
            <h3 className="font-normal text-gray-600 dark:text-gray-400" data-id="element-6220">
              Popular Highlights
            </h3>
          </div>
          <p className="text-xs text-gray-500 dark:text-gray-500 ml-7" data-id="element-6221">
            The most liked and engaged content from your favorite angels.
          </p>
        </div>}
      {/* Daily Targets tab intro message - redesigned with glassmorphism */}
      {activeTab === 'dailyTargets' && <div className="p-3 bg-white/5 dark:bg-white/5 backdrop-filter backdrop-blur-md border border-white/8 dark:border-white/8 m-4 rounded-2xl shadow-none animate-in fade-in duration-300" data-id="element-6222">
          <div className="flex items-center gap-2 mb-1" data-id="element-6223">
            <span className="text-lg opacity-80" data-id="element-6224">🎯</span>
            <h3 className="font-normal text-gray-600 dark:text-gray-400" data-id="element-6225">
              Daily Targets
            </h3>
          </div>
          <p className="text-xs text-gray-500 dark:text-gray-500 ml-7" data-id="element-6226">
            Complete these daily interactions to earn special rewards and boost
            your intimacy level.
          </p>
          <div className="mt-2 ml-7" data-id="element-6227">
            <div className="h-1 bg-white/10 dark:bg-white/10 rounded-full overflow-hidden" data-id="element-6228">
              <div className="h-full bg-gradient-to-r from-pink-300/50 to-purple-300/50 rounded-full transition-all duration-300" style={{
            width: '33%'
          }} data-id="element-6229"></div>
            </div>
            <div className="flex items-center justify-between mt-1" data-id="element-6230">
              <span className="text-xs text-gray-500 dark:text-gray-500" data-id="element-6231">
                1/3 completed
              </span>
              <span className="text-xs text-pink-400/70" data-id="element-6232">Reward: 5 💎</span>
            </div>
          </div>
        </div>}
      {/* Feed Content */}
      <div className="divide-y divide-gray-200/10" data-id="element-6233">
        {Array.isArray(renderContent()) ? renderContent().map(post => renderPost(post)) : renderContent()}
      </div>
      {/* Adding GenerationUpsellCTA to the bottom of the feed */}
      <div className="mt-6 mb-6" data-id="element-6234">
        <GenerationUpsellCTA data-id="element-6235" />
      </div>
      {/* Show empty state if no polls */}
      {activeTab === 'polls' && renderContent().length === 0 && <div className="flex flex-col items-center justify-center py-12 text-center p-4" data-id="element-6236">
          <div className="w-16 h-16 flex items-center justify-center bg-white/5 backdrop-blur-md rounded-full mb-4" data-id="element-6237">
            <span className="text-2xl" data-id="element-6238">📊</span>
          </div>
          <h3 className="text-lg font-normal mb-2 text-gray-600 dark:text-gray-400" data-id="element-6239">
            No active polls
          </h3>
          <p className="text-sm text-gray-500 dark:text-gray-500 max-w-md" data-id="element-6240">
            There are no active polls at the moment. Check back soon as angels
            frequently ask for your opinion!
          </p>
        </div>}
      {/* Add special empty state for For You tab */}
      {activeTab === 'forYou' && forYouPersonalizedPosts.length === 0 && <div className="flex flex-col items-center justify-center py-12 text-center p-4" data-id="element-6241">
          <div className="w-16 h-16 flex items-center justify-center bg-white/5 backdrop-blur-md rounded-full mb-4" data-id="element-6242">
            <span className="text-2xl" data-id="element-6243">🔥</span>
          </div>
          <h3 className="text-lg font-normal mb-2 text-gray-600 dark:text-gray-400" data-id="element-6244">
            No personalized content yet
          </h3>
          <p className="text-sm text-gray-500 dark:text-gray-500 max-w-md" data-id="element-6245">
            Interact with angels to start receiving personalized content and
            messages!
          </p>
          <button className="mt-4 px-4 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-sm font-medium" onClick={() => onNavigate && onNavigate('discovery_feed')} data-id="element-6246">
            Discover Angels
          </button>
        </div>}
      {/* Add special empty state for Following tab */}
      {activeTab === 'following' && followingPosts.length === 0 && <div className="flex flex-col items-center justify-center py-12 text-center p-4" data-id="element-6247">
          <div className="w-16 h-16 flex items-center justify-center bg-white/5 backdrop-blur-md rounded-full mb-4" data-id="element-6248">
            <span className="text-2xl" data-id="element-6249">👥</span>
          </div>
          <h3 className="text-lg font-normal mb-2 text-gray-600 dark:text-gray-400" data-id="element-6250">
            No content from followed angels
          </h3>
          <p className="text-sm text-gray-500 dark:text-gray-500 max-w-md" data-id="element-6251">
            When you follow angels, their public content will appear here. Start
            by following some angels you like!
          </p>
          <button className="mt-4 px-4 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-sm font-medium" onClick={() => onNavigate && onNavigate('discovery_feed')} data-id="element-6252">
            Discover Angels
          </button>
        </div>}
      {/* Floating Action Button */}
      <FloatingActionButton onActionSelect={handleActionSelect} data-id="element-6253" />
      {/* Audio Element (hidden) */}
      <audio ref={audioRef} className="hidden" data-id="element-6254" />
      {/* Unlock Modal */}
      {showUnlockModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-6255">
          <div className="w-full max-w-sm bg-white rounded-xl border border-gray-200 overflow-hidden animate-in zoom-in-90 duration-300" data-id="element-6256">
            <div className="p-4 border-b border-gray-200" data-id="element-6257">
              <h3 className="font-bold text-gray-800" data-id="element-6258">
                Unlock Premium Content
              </h3>
            </div>
            <div className="p-4" data-id="element-6259">
              <p className="text-sm text-gray-600 mb-4" data-id="element-6260">
                Unlock this exclusive content for 8 gems. This is a one-time
                purchase.
              </p>
              <div className="flex items-center justify-center gap-2 mb-4" data-id="element-6261">
                <div className="w-16 h-16 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 flex items-center justify-center text-2xl" data-id="element-6262">
                  💎
                </div>
              </div>
              <div className="flex gap-2" data-id="element-6263">
                <span className="text-sm text-gray-700" data-id="element-6264">Your balance:</span>
                <span className="font-bold text-gray-800" data-id="element-6265">15 💎</span>
              </div>
              <div className="flex gap-2" data-id="element-6266">
                <button className="flex-1 py-2 bg-gray-100 rounded-lg text-sm text-gray-800" onClick={() => setShowUnlockModal(false)} data-id="element-6267">
                  Cancel
                </button>
                <button className="flex-1 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white text-sm font-medium" onClick={confirmUnlock} data-id="element-6268">
                  Unlock Now
                </button>
              </div>
            </div>
          </div>
        </div>}
      {/* Tip Options Modal */}
      {showTipOptions && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-6269">
          <div className="w-full max-w-sm bg-white rounded-xl border border-gray-200 overflow-hidden animate-in zoom-in-90 duration-300" data-id="element-6270">
            <div className="p-4 border-b border-gray-200" data-id="element-6271">
              <h3 className="font-bold text-gray-800" data-id="element-6272">Send a Tip</h3>
            </div>
            <div className="p-4" data-id="element-6273">
              <p className="text-sm text-gray-600 mb-4" data-id="element-6274">
                Show your appreciation with gems! Top tippers get special
                recognition.
              </p>
              <div className="grid grid-cols-3 gap-2 mb-4" data-id="element-6275">
                {[5, 10, 20, 50, 100, 200].map(amount => <button key={amount} className="p-3 bg-gray-100 rounded-lg border border-gray-200 hover:border-pink-500 transition text-center" onClick={() => sendTip(amount)} data-id="element-6276">
                    <div className="text-lg mb-1" data-id="element-6277">💎</div>
                    <div className="text-sm font-medium text-gray-800" data-id="element-6278">
                      {amount}
                    </div>
                  </button>)}
              </div>
              <div className="flex items-center justify-between mb-4" data-id="element-6279">
                <span className="text-sm text-gray-700" data-id="element-6280">Your balance:</span>
                <span className="font-bold text-gray-800" data-id="element-6281">15 💎</span>
              </div>
              <button className="w-full py-2 bg-gray-100 rounded-lg text-sm text-gray-800" onClick={() => setShowTipOptions(false)} data-id="element-6282">
                Cancel
              </button>
            </div>
          </div>
        </div>}
      {/* Video Generation Modal */}
      {showVideoUpsellModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-6283">
          <VideoGenerationUpsell onClose={() => setShowVideoUpsellModal(false)} onPurchase={(duration, tokens) => {
        // Handle purchase logic
        setShowVideoUpsellModal(false);
        // Show XP earned animation
        setXpEarned({
          id: 'video-purchase',
          value: 5
        });
        setTimeout(() => setXpEarned(null), 1500);
      }} data-id="element-6284" />
        </div>}
      {/* Image Generation Modal */}
      {showImageGeneratorModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-6285">
          <ImageGenerationUpsell modal onClose={() => setShowImageGeneratorModal(false)} onGenerate={options => {
        // Handle generation logic
        setShowImageGeneratorModal(false);
      }} data-id="element-6286" />
        </div>}
      {/* Daily Targets Modal */}
      {showDailyTargetsModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-6287">
          <div className="relative w-full max-w-md max-h-[80vh] animate-in zoom-in-90 duration-300 bg-white dark:bg-gray-900 rounded-lg shadow-lg flex flex-col" data-id="element-6288">
            <div className="sticky top-0 z-10 p-4 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 rounded-t-lg flex items-center justify-between" data-id="element-6289">
              <h3 className="text-lg font-bold text-gray-800 dark:text-white flex items-center gap-2" data-id="element-6290">
                <Trophy size={18} className="text-pink-500" data-id="element-6291" />
                Daily Targets
              </h3>
              <button className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800" onClick={() => setShowDailyTargetsModal(false)} data-id="element-6292">
                <X size={18} className="text-gray-500 dark:text-gray-400" data-id="element-6293" />
              </button>
            </div>
            <div className="overflow-y-auto p-4 flex-1 scrollbar-hide" data-id="element-6294">
              <div className="space-y-3" data-id="element-6295">
                {/* New questionnaire target with highest reward */}
                <div className="p-3 bg-gradient-to-r from-blue-900/10 to-purple-900/10 dark:from-blue-900/20 dark:to-purple-900/20 rounded-lg border border-blue-200/20 dark:border-blue-800/30" data-id="element-6296">
                  <div className="flex items-center gap-3" data-id="element-6297">
                    <div className="w-9 h-9 flex items-center justify-center bg-blue-500/10 dark:bg-blue-500/20 rounded-full text-blue-500 flex-shrink-0" data-id="element-6298">
                      <MessageCircle size={18} data-id="element-6299" />
                    </div>
                    <div className="flex-1" data-id="element-6300">
                      <div className="flex items-center justify-between" data-id="element-6301">
                        <h3 className="font-medium text-sm" data-id="element-6302">
                          Complete Questionnaire
                        </h3>
                        <div className="text-xs text-pink-500 font-semibold" data-id="element-6303">
                          200 💗
                        </div>
                      </div>
                      <p className="text-xs text-gray-700 dark:text-gray-300 mt-1" data-id="element-6304">
                        Share your preferences to personalize your experience
                      </p>
                      <div className="mt-2" data-id="element-6305">
                        <div className="flex items-center justify-between mb-1" data-id="element-6306">
                          <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-6307">
                            Progress
                          </span>
                          <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-6308">
                            0/1
                          </span>
                        </div>
                        <div className="h-1.5 bg-gray-200 dark:bg-gray-800 rounded-full overflow-hidden" data-id="element-6309">
                          <div className="h-full bg-gradient-to-r from-blue-500 to-purple-500 rounded-full" style={{
                        width: '0%'
                      }} data-id="element-6310"></div>
                        </div>
                      </div>
                      <button className="mt-3 w-full py-1.5 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full text-white text-xs font-medium hover:shadow-lg hover:shadow-blue-500/20 transition-all duration-300" onClick={() => {
                    setShowDailyTargetsModal(false);
                    // Open the questionnaire using the context hook
                    openQuestionnaire();
                  }} data-id="element-6311">
                        Start Questionnaire
                      </button>
                    </div>
                  </div>
                </div>
                {/* Premium purchase - 50 tokens */}
                <div className="p-3 bg-gradient-to-r from-purple-900/10 to-blue-900/10 dark:from-purple-900/20 dark:to-blue-900/20 rounded-lg border border-purple-200/20 dark:border-purple-800/30" data-id="element-6312">
                  <div className="flex items-center gap-3" data-id="element-6313">
                    <div className="w-9 h-9 flex items-center justify-center bg-purple-500/10 dark:bg-purple-500/20 rounded-full text-purple-500 flex-shrink-0" data-id="element-6314">
                      <Diamond size={18} data-id="element-6315" />
                    </div>
                    <div className="flex-1" data-id="element-6316">
                      <div className="flex items-center justify-between" data-id="element-6317">
                        <h3 className="font-medium text-sm" data-id="element-6318">
                          Premium Purchase
                        </h3>
                        <div className="text-xs text-pink-500 font-semibold" data-id="element-6319">
                          50 💗
                        </div>
                      </div>
                      <p className="text-xs text-gray-700 dark:text-gray-300 mt-1" data-id="element-6320">
                        Purchase premium content with DesireGems 💎
                      </p>
                      <div className="mt-2" data-id="element-6321">
                        <div className="flex items-center justify-between mb-1" data-id="element-6322">
                          <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-6323">
                            Progress
                          </span>
                          <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-6324">
                            0/1
                          </span>
                        </div>
                        <div className="h-1.5 bg-gray-200 dark:bg-gray-800 rounded-full overflow-hidden" data-id="element-6325">
                          <div className="h-full bg-gradient-to-r from-purple-500 to-blue-500 rounded-full" style={{
                        width: '0%'
                      }} data-id="element-6326"></div>
                        </div>
                      </div>
                      <button className="mt-3 w-full py-1.5 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full text-white text-xs font-medium hover:shadow-lg hover:shadow-purple-500/20 transition-all duration-300" onClick={() => {
                    // Navigate to the dedicated Premium Content page
                    const navigateEvent = new CustomEvent('navigate', {
                      detail: {
                        section: 'premium'
                      }
                    });
                    document.dispatchEvent(navigateEvent);
                    setShowDailyTargetsModal(false); // Close the modal after navigation
                  }} data-id="element-6327">
                        Browse Premium Content
                      </button>
                    </div>
                  </div>
                </div>
                {/* DickPic Challenge - 25 tokens */}
                <div className="p-3 bg-gradient-to-r from-pink-900/10 to-purple-900/10 dark:from-pink-900/20 dark:to-purple-900/20 rounded-lg border border-pink-200/20 dark:border-pink-800/30" data-id="element-6328">
                  <div className="flex items-center gap-3" data-id="element-6329">
                    <div className="w-9 h-9 flex items-center justify-center bg-pink-500/10 dark:bg-pink-500/20 rounded-full text-pink-500 flex-shrink-0" data-id="element-6330">
                      <Camera size={18} data-id="element-6331" />
                    </div>
                    <div className="flex-1" data-id="element-6332">
                      <div className="flex items-center justify-between" data-id="element-6333">
                        <h3 className="font-medium text-sm" data-id="element-6334">
                          DickPic Challenge
                        </h3>
                        <div className="text-xs text-pink-500" data-id="element-6335">25 💗</div>
                      </div>
                      <p className="text-xs text-gray-700 dark:text-gray-300 mt-1" data-id="element-6336">
                        Get a personal rating from your favorite angel
                      </p>
                      <div className="mt-2" data-id="element-6337">
                        <button className="w-full py-1.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-xs font-medium hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300" onClick={() => {
                      setShowDailyTargetsModal(false);
                      setShowPhotoRatingFlow(true);
                    }} data-id="element-6338">
                          Start Challenge
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Like 5 Posts - 15 tokens */}
                <div className="p-3 bg-gradient-to-r from-pink-900/10 to-purple-900/10 dark:from-pink-900/20 dark:to-purple-900/20 rounded-lg border border-pink-200/20 dark:border-pink-800/30" data-id="element-6339">
                  <div className="flex items-center gap-3" data-id="element-6340">
                    <div className="w-9 h-9 flex items-center justify-center bg-pink-500/10 dark:bg-pink-500/20 rounded-full text-pink-500 flex-shrink-0" data-id="element-6341">
                      <Heart size={18} data-id="element-6342" />
                    </div>
                    <div className="flex-1" data-id="element-6343">
                      <div className="flex items-center justify-between" data-id="element-6344">
                        <h3 className="font-medium text-sm" data-id="element-6345">Like 5 Posts</h3>
                        <div className="text-xs text-pink-500" data-id="element-6346">15 💗</div>
                      </div>
                      <p className="text-xs text-gray-700 dark:text-gray-300 mt-1" data-id="element-6347">
                        Show some love to your favorite angels
                      </p>
                      <div className="mt-2" data-id="element-6348">
                        <div className="flex items-center justify-between mb-1" data-id="element-6349">
                          <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-6350">
                            Progress
                          </span>
                          <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-6351">
                            {Object.keys(likedPosts).length}/5
                          </span>
                        </div>
                        <div className="h-1.5 bg-gray-200 dark:bg-gray-800 rounded-full overflow-hidden" data-id="element-6352">
                          <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full" style={{
                        width: `${Object.keys(likedPosts).length / 5 * 100}%`
                      }} data-id="element-6353"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Send a Gift - 10 tokens */}
                <div className="p-3 bg-gradient-to-r from-pink-900/10 to-purple-900/10 dark:from-pink-900/20 dark:to-purple-900/20 rounded-lg border border-pink-200/20 dark:border-pink-800/30" data-id="element-6354">
                  <div className="flex items-center gap-3" data-id="element-6355">
                    <div className="w-9 h-9 flex items-center justify-center bg-pink-500/10 dark:bg-pink-500/20 rounded-full text-pink-500 flex-shrink-0" data-id="element-6356">
                      <Gift size={18} data-id="element-6357" />
                    </div>
                    <div className="flex-1" data-id="element-6358">
                      <div className="flex items-center justify-between" data-id="element-6359">
                        <h3 className="font-medium text-sm" data-id="element-6360">Send a Gift</h3>
                        <div className="text-xs text-pink-500" data-id="element-6361">10 💗</div>
                      </div>
                      <p className="text-xs text-gray-700 dark:text-gray-300 mt-1" data-id="element-6362">
                        Send a gift to make your favorite angel's day
                      </p>
                      <div className="mt-2" data-id="element-6363">
                        <div className="flex items-center justify-between mb-1" data-id="element-6364">
                          <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-6365">
                            Progress
                          </span>
                          <span className="text-xs text-gray-500 dark:text-gray-400" data-id="element-6366">
                            0/1
                          </span>
                        </div>
                        <div className="h-1.5 bg-gray-200 dark:bg-gray-800 rounded-full overflow-hidden" data-id="element-6367">
                          <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full" style={{
                        width: '0%'
                      }} data-id="element-6368"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Daily Streak info */}
                <div className="p-3 bg-gradient-to-r from-blue-900/10 to-purple-900/10 dark:from-blue-900/20 dark:to-purple-900/20 rounded-lg border border-blue-200/20 dark:border-blue-800/30" data-id="element-6369">
                  <div className="flex items-center justify-between mb-2" data-id="element-6370">
                    <h3 className="font-medium text-sm" data-id="element-6371">Daily Streak</h3>
                    <div className="flex items-center gap-1" data-id="element-6372">
                      <span className="text-yellow-500" data-id="element-6373">🔥</span>
                      <span className="font-bold text-sm" data-id="element-6374">3 Days</span>
                    </div>
                  </div>
                  <p className="text-xs text-gray-700 dark:text-gray-300" data-id="element-6375">
                    Complete all daily targets to maintain your streak and earn
                    bonus rewards!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>}
      {/* PhotoRatingFlow Modal */}
      {showPhotoRatingFlow && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-6376">
          <PhotoRatingFlow onClose={() => setShowPhotoRatingFlow(false)} data-id="element-6377" />
        </div>}
      {/* Stories Bar */}
      <div className="py-4 px-4 overflow-x-auto" data-id="element-6378">
        <div className="flex space-x-4" data-id="element-6379">
          {stories.map((story, index) => <div key={story.id} className="flex flex-col items-center" onClick={() => openStory(index)} data-id="element-6380">
              <div className={`relative w-16 h-16 rounded-full ${story.viewed ? 'border-2 border-gray-300' : 'border-2 border-gradient-to-r from-pink-500 to-purple-500'} p-0.5`} data-id="element-6381">
                <img src={story.avatar} alt={story.user} className="w-full h-full rounded-full object-cover" data-id="element-6382" />
                {story.live && <div className="absolute top-0 right-0 bg-red-500 text-white text-[8px] px-1 rounded" data-id="element-6383">
                    LIVE
                  </div>}
                {story.new && <div className="absolute bottom-0 right-0 w-4 h-4 bg-pink-500 rounded-full flex items-center justify-center border border-white" data-id="element-6384">
                    <span className="text-white text-[8px]" data-id="element-6385">+1</span>
                  </div>}
              </div>
              <span className="text-xs mt-1 truncate w-16 text-center text-gray-800" data-id="element-6386">
                {story.user}
              </span>
            </div>)}
        </div>
      </div>

      {/* Story Modal */}
      {showStoryModal && activeStory !== null && <div className="fixed inset-0 z-50 bg-black flex items-center justify-center" onClick={closeStory} data-id="element-6387">
          <div className="relative w-full max-w-sm" data-id="element-6388">
            <div className="absolute top-4 left-4 right-4 flex items-center z-10" data-id="element-6389">
              <div className="flex-1 h-1 bg-gray-700 rounded-full overflow-hidden" data-id="element-6390">
                <div className="h-full bg-white animate-story-progress" data-id="element-6391"></div>
              </div>
            </div>
            <div className="absolute top-8 left-4 flex items-center gap-2 z-10" data-id="element-6392">
              <img src={stories[activeStory].avatar} alt={stories[activeStory].user} className="w-8 h-8 rounded-full object-cover border border-white" data-id="element-6393" />
              <span className="text-white text-sm font-medium" data-id="element-6394">
                {stories[activeStory].user}
              </span>
              {stories[activeStory].live && <span className="bg-red-500 text-white text-xs px-1.5 py-0.5 rounded flex items-center" data-id="element-6395">
                  LIVE{' '}
                  <span className="w-1.5 h-1.5 bg-white rounded-full animate-pulse ml-1" data-id="element-6396"></span>
                </span>}
            </div>
            <img src={stories[activeStory].image} alt="Story" className="w-full h-[calc(100vh-100px)] object-cover" data-id="element-6397" />
            <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between" data-id="element-6398">
              <input type="text" placeholder="Reply to story..." className="flex-1 bg-white/10 backdrop-blur-sm text-white rounded-full px-4 py-2 text-sm border border-white/20" data-id="element-6399" />
              <button className="ml-2 w-10 h-10 flex items-center justify-center bg-pink-500 rounded-full" data-id="element-6400">
                <MessageCircle size={18} className="text-white" data-id="element-6401" />
              </button>
            </div>
          </div>
        </div>}

      {/* Add CSS for enhanced image rendering */}
      <style jsx data-id="element-6402">{`
        .post-image-container {
          max-width: 820px;
          margin: 0 auto;
          min-height: 100px;
        }
        .post-image {
          width: 100%;
          height: auto;
          object-fit: cover;
          border-radius: 16px;
          image-rendering: optimizeQuality;
        }
        @keyframes story-progress {
          from {
            width: 0;
          }
          to {
            width: 100%;
          }
        }
        .animate-story-progress {
          animation: story-progress 5s linear forwards;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        @keyframes float-up {
          0% {
            opacity: 0;
            transform: translateY(0);
          }
          20% {
            opacity: 1;
          }
          100% {
            opacity: 0;
            transform: translateY(-20px);
          }
        }
        .animate-float-up {
          animation: float-up 1.5s ease-out forwards;
        }
        @keyframes pulse {
          0% {
            transform: scaleY(0.6);
          }
          100% {
            transform: scaleY(1);
          }
        }
        .shadow-glow {
          box-shadow: 0 0 15px;
        }
      `}</style>
    </div>;
};